export default "__VITE_ASSET__e90e6d43__"